import client from "../client/client";

class CommitmentService {
	createCommitment({ projectId }, payload, cancelToken) {
		return client.post(`/project/${projectId}/commitments/`, {
			payload,
			config: { cancelToken },
		});
	}

	updateCommitment({ commitmentId }, payload, cancelToken) {
		return client.put(`/commitments/${commitmentId}`, {
			payload,
			config: { cancelToken },
		});
	}

	bulkDeleteCommitments({ projectId }, payload, cancelToken) {
		return client.post(`/project/${projectId}/commitments/actions/bulk-delete`, {
			payload,
			config: { cancelToken },
		});
	}

	searchInCommitment({ projectId }, payload, { page = 0, limit = 25 }, cancelToken) {
		return client.post(`/project/${projectId}/commitment/search`, {
			payload,
			params: { page, limit },
			config: { cancelToken },
		});
	}

	getPossibleValuesOfField({ projectId, fieldUuid, hasPenalty }, payload, cancelToken) {
		return client.post(`/project/${projectId}/commitments/fields/${fieldUuid}`, {
			payload,
			params: { hasPenalty },
			config: { cancelToken },
		});
	}

	validateCommitment({ commitmentId, isValidated }, cancelToken) {
		return client.patch(`/commitments/${commitmentId}/validate`, {
			params: { isValidated },
			config: { cancelToken },
		});
	}

	getCommitmentFilters({ projectId }, cancelToken) {
		return client.get(`/project/${projectId}/commitments/filter`, {
			config: { cancelToken },
		});
	}

	getCommitmentDetails({ commitmentId, fieldUuid }, cancelToken) {
		return client.get(`/commitments/${commitmentId}/fields/${fieldUuid}`, {
			config: { cancelToken },
		});
	}

	associateContent({ projectId, commitmentId }, payload, cancelToken) {
		return client.post(`/projects/${projectId}/commitments/${commitmentId}/information`, {
			payload,
			config: { cancelToken },
		});
	}

	getHistory({ commitmentId }, { page = 0, limit = 25, filter }, cancelToken) {
		return client.get(`/commitments/${commitmentId}/history`, {
			params: { page, limit, filter },
			config: { cancelToken },
		});
	}

	getFieldValues(projectId, fieldUuid, cancelToken) {
		return client.get(`/project/${projectId}/commitments/fields/${fieldUuid}/values`, {
			config: { cancelToken },
		});
	}

	isLaunchAvailable({ projectId }, cancelToken) {
		return client.get(`/projects/${projectId}/commitment/launch/available`, {
			config: { cancelToken },
		});
	}

	hasCommitment({ projectId }, cancelToken) {
		return client.get(`/projects/${projectId}/has-commitment`, {
			config: { cancelToken },
		});
	}

	getAllComments({ commitmentId }, { page = 0, limit = 25, isOpen = true }, cancelToken) {
		return client.get(`/commitment/${commitmentId}/comments/all`, {
			params: { page, limit, isOpen },
			config: { cancelToken },
		});
	}

	getCommentsCount({ commitmentId }, cancelToken) {
		return client.get(`/commitment/${commitmentId}/comments/count`, {
			config: { cancelToken },
		});
	}

	addComment({ commitmentId }, payload, cancelToken) {
		return client.post(`/commitment/${commitmentId}/comments`, {
			payload,
			config: { cancelToken },
		});
	}

	addChildComment({ commitmentId, commentId }, payload, cancelToken) {
		return client.post(`/commitment/${commitmentId}/comments/${commentId}`, {
			payload,
			config: { cancelToken },
		});
	}

	updateComment({ commitmentId, commentId }, payload, cancelToken) {
		return client.patch(`/commitment/${commitmentId}/comments/${commentId}`, {
			payload,
			config: { cancelToken },
		});
	}

	deleteComment({ commitmentId, commentId }, cancelToken) {
		return client.delete(`/commitment/${commitmentId}/comments/${commentId}`, {
			config: { cancelToken },
		});
	}

	getChildComments({ commitmentId, commentId }, { page = 0, limit = 25 }, cancelToken) {
		return client.get(`/commitment/${commitmentId}/comments/${commentId}/children`, {
			params: { page, limit },
			config: { cancelToken },
		});
	}

	updateDiscussionStatus({ commitmentId, commentId }, isOpen, cancelToken) {
		return client.patch(`/commitment/${commitmentId}/comments/${commentId}/discussion`, {
			payload: isOpen,
			config: { cancelToken },
		});
	}

	getSources({ projectId, commitmentId }, cancelToken) {
		return client.get(`/projects/${projectId}/commitments/${commitmentId}/sources`, {
			config: { cancelToken },
		});
	}

	deleteSource({ projectId, commitmentId, informationId }, cancelToken) {
		return client.delete(`/projects/${projectId}/commitments/${commitmentId}/information/${informationId}`, {
			config: { cancelToken },
		});
	}

	launchDetection({ projectId }, cancelToken) {
		return client.get(`/projects/${projectId}/commitments/agent-run`, {
			config: { cancelToken },
		});
	}

	getPilots({ projectId }, { name }, cancelToken) {
		return client.get(`/projects/${projectId}/commitments/pilots`, {
			params: { name },
			config: { cancelToken },
		});
	}

	checkLaunch({ projectId }, cancelToken) {
		return client.get(`/projects/${projectId}/commitments/agent/progress`, { config: { cancelToken } });
	}

	exportCommitments({ projectId }, payload, cancelToken) {
		return client.downloadPost(`/projects/${projectId}/commitments/export`, { payload, config: { cancelToken } });
	}

	likeDetectedContent({ projectId, commitmentId, informationId }, isVerified, cancelToken) {
		return client.patch(`/projects/${projectId}/commitment/${commitmentId}/information/${informationId}/status`, {
			payload: isVerified,
			config: { cancelToken },
		});
	}
}

export default new CommitmentService();
